require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-in-an-age-where-data-is-king-it-s-still-only-ideas-that-move-people.json") })
        }
      }, "path---news-in-an-age-where-data-is-king-it-s-still-only-ideas-that-move-people");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-in-an-age-where-data-is-king-it-s-still-only-ideas-that-move-people!./.cache/json/news-in-an-age-where-data-is-king-it-s-still-only-ideas-that-move-people.json
// module id = 1422
// module chunks = 231608221292675